// import logo from './logo.svg';
import './App.css';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom"
import Page404 from './Layout/Page404';
import { ConfigProvider } from '../src/Context/ConfigContext'
import Swal from 'sweetalert2';
import routes from './Routes/Routes'
import AppLayout from './Layout/AppLayout';
import Login from './Pages/LoginPage/Login';
import ForgotPassword from './Pages/LoginPage/ForgotPassword';
import OtpVerification from './Pages/LoginPage/OtpVerification';
import EmailNotFound from './Pages/LoginPage/EmailNotFound';
import ConfirmPassword from './Pages/LoginPage/ConfirmPassword';
import { useCallback, useEffect, useState } from 'react';
import OfferLetter from './Pages/GuestProfile/OfferLetter';
import CandidateDetails from './Pages/GuestProfile/CandidateDetails';
import AppointmentLetter from './Pages/GuestProfile/AppointmentLetter';
import InductionProcess from './Pages/GuestProfile/InductionProcess';
import axios from 'axios';
import LoginNew from './Pages/LoginPage/LoginNew';
function App() {

  const [checkGuestEmployee,setCheckGuestEmployee]=useState(window.location.href.includes("offer-letter"));
  const [checkCandidateDetails,setCheckCandidateDetails]=useState(window.location.href.includes("candidate-details"));
  const [checkAppointmentLetter,setCheckAppointmentLetter]=useState(window.location.href.includes("appointment-letter"));
  const [inductionProcess,setInductionProcess]=useState(window.location.href.includes("induction-process"));
  const [accessibleRoutes, setAccessibleRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [apiURL, setAPIURL] = useState('http://143.110.190.50:3189/');
    // const [apiURL, setAPIURL] = useState('https://143.110.190.50:4001/');
    // const [apiURL, setAPIURL] = useState('https://uatempapi.abstarthr.in/');
    const [apiURL, setAPIURL] = useState('https://empapi.abstarthr.in/');
    // const [apiURL, setAPIURL] = useState('http://localhost:3189/');
    // const [apiURL, setAPIURL] = useState('http://localhost:4005/');
  
  // employee_id and company_id is replace with x-employee-id and x-company-id because in 
  // browser or backend server  is removing employee_id and company_id auto.
  const [apiHeaderJSON, setHeaderJSON] = useState({
    token: localStorage.getItem("token_emp"),
    "Content-Type": "application/json",
    "x-company-id": localStorage.getItem("company_id_emp"),
    "x-employee-id": localStorage.getItem("employee_id_emp"),
  });

  // const [apiHeaderJSON, setHeaderJSON] = useState({
  //   token: localStorage.getItem("token_emp"),
  //   "Content-Type": "application/json",
  //   company_id: localStorage.getItem("company_id_emp"),
  //   employee_id: localStorage.getItem("employee_id_emp"),
  // });

  useEffect(()=>{
    setCheckGuestEmployee(window.location.href.includes("offer-letter"));
    setCheckCandidateDetails(window.location.href.includes("candidate-details"));
    setInductionProcess(window.location.href.includes("induction-process"));
  },[]);

 const findMatchingRoutes = (response, routes) => {
    const matchedRoutes = [];
    const checkPathMatch = (modules, routes) => {
      for (const module of modules) {
        if (module.path) {
          const match = routes.find((route) => {
            return route.path.includes(module.path)
          });
          if (match) {
            matchedRoutes.push(match);
          }
        }

        // Recursively check for sub_modules
        if (module.sub_module) {
          // console.log("module.sub_module",module.sub_module)
          checkPathMatch(module.sub_module, routes);
        }
      }
    };

    checkPathMatch(response, routes);

    return matchedRoutes;
  };

  const handleLogout = () => {
    localStorage.removeItem("token_emp");
    localStorage.removeItem("company_id_emp");
    localStorage.removeItem("employee_id_emp");
    localStorage.removeItem("employee_code_emp");
    localStorage.removeItem("induction_status");
    window.location.href = '/'
  };
  const getList = useCallback(() => {
    const headers = apiHeaderJSON;
    // console.log("headers =====>",headers);
    setLoading(true);
    axios
      .get(`${apiURL}User/GetEmployeeModuleHierarchy`, {
        params: {},
        headers,
      })
      .then((response) => {
        let data = response.data;
        // console.log("GetEmployeeModuleHierarchy",data);
        if (response.data.success === true) {
          const result = data?.result;
          console.log("result",result);
          const matchedRoutes = findMatchingRoutes(result, routes);
          // const matchedRoute = result?.find((route) => {
          //   return route.path.includes("/");
          // });
          // if(!matchedRoute){
          //   matchedRoutes.unshift({ path: "/", element: <DashboardTemp /> },);
          // }
          // console.log("matchedRoutes",matchedRoutes);
          // for (const path of otherRoutes) {
          //   if (path) {
          //     const match = matchedRoutes.find((route) => {
          //       return route.path.includes(path)
          //     });
          //     if (match && path==="LetterHeadList") {
          //       matchedRoutes.push(...letterHeadRoutes);
          //     }
          //   }
          // }
          matchedRoutes.push({ path: "*", element: <Page404/> });
          // console.log("matchedRoutes ===>", matchedRoutes);
          setAccessibleRoutes(matchedRoutes || []);
        } else {
          console.error("Error fetching list");
          Swal.fire({
          title: `<strong>Failed</strong>`,
          text: response?.data?.message,
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText:"Logout",
          allowOutsideClick: false
          }).then((result) => {
              if (result.isConfirmed) {
                  handleLogout();
              }
          });
          // Swal.fire({
          // title: `<strong>Failed</strong>`,
          // text: response?.data?.message === "session has been expired, please login again." || response.data.message==="Invalid Header" || response?.data?.message==="Your joining date is yet to come. Access is not allowed till then."
          //   ? `${response.data.message} Please Login.` : response?.data?.message,
          // icon: 'error',
          // showConfirmButton: true,
          // confirmButtonText: response?.data?.message === "session has been expired, please login again." || response.data.message==="Invalid Header" || response?.data?.message==="Your joining date is yet to come. Access is not allowed till then."
          //   ? "Login" : "OK",
          // allowOutsideClick: false
          // }).then((result) => {
          //     if ((response?.data?.message === "session has been expired, please login again." || response.data.message==="Invalid Header" || response?.data?.message==="Your joining date is yet to come. Access is not allowed till then.") && result.isConfirmed) {
          //         handleLogout();
          //     }
          // });
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        console.log("error", error);
      });
  }, [apiHeaderJSON, apiURL]);

  useEffect(() => {
    if(localStorage.getItem("token_emp")){
        getList();
    }
    else{
      if(!localStorage.getItem("reset_emp") && !localStorage.getItem("token_emp")){
        localStorage.setItem("reset_emp",true);
        console.log("entered")
          handleLogout();
      }
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
              <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                  </div>
              </div>
            </div>;
  }

  let mRoutes = [];
  if(checkGuestEmployee){
    mRoutes = [
        { path: '/offer-letter', element: <OfferLetter />},
    ];
  }
  else if(checkCandidateDetails){
    mRoutes = [
        { path: '/candidate-details', element: <CandidateDetails />},
    ];
  }
  else if(checkAppointmentLetter){
    mRoutes = [
        { path: '/appointment-letter', element: <AppointmentLetter />},
    ];
  }
  else if(localStorage.getItem("induction_status")==="0"){
    mRoutes = [
      {
        element: <AppLayout />,
        errorElement: <Page404 />,
        children: [
          { path: '/', element: <InductionProcess /> },
          // { path: '/induction-process', element: <InductionProcess />},
        ]
      }
        
    ];
  }
  else if (localStorage.getItem('token_emp') && localStorage.getItem('token_emp') !== '') {
    // console.log("accessibleRoutes",accessibleRoutes);
    mRoutes = [
      {
        element: <AppLayout />,
        errorElement: <Page404 />,
        children:  accessibleRoutes || [],
      }
    ];
  } else {
    if(!localStorage.getItem("reset_emp") && !localStorage.getItem("token_emp")){
      localStorage.setItem("reset_emp",true);
      console.log("entered")
      window.location.href = '/';
    }

    mRoutes = [
      // { path: '/Login', element: <Login /> },
      { path: '/Login', element: <LoginNew /> },
      { path: "/ForgotPassword", element: <ForgotPassword /> },
      { path: "/OtpVerification", element: <OtpVerification /> },
      { path: "/EmailNotFound", element: <EmailNotFound /> },
      { path: "/ConfirmPassword/:employee_id", element: <ConfirmPassword /> },
      // { path: '/', element: <Login /> },
      { path: '/', element: <LoginNew /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ]
  }
  // console.log(mRoutes);
  const router = createBrowserRouter(mRoutes);
  return (
    <div>
      <ConfigProvider>
        <RouterProvider router={router} />
      </ConfigProvider>
    </div>
  )

}


export default App;
